import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../../../../components/library/buttons/Button';
import DateTime from '../../../../../components/library/common/DateTime';
import EmdashText from '../../../../../components/library/common/EmdashText';
import LoadingTextValue from '../../../../../components/library/layout/LoadingTextValue';
import VerticalNameChildren from '../../../../../components/library/layout/VerticalNameChildren';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask';
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import TicketActions from '../../../../../store/ticketRedux';
import { TaskStatus } from '../../../services/TaskStatus';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook';
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { useWorkflowState } from '../../hooks/useWorkflowStateHook';
import '../Workflow.scss';
import { useTicketState } from '../../hooks/useTicketStateHook';
import DoxExplorer from '../../dox/Explorer/doxExplorer';
import DoxUploader from '../../dox/Uploader/doxUploader';
import { createInProgressTaskCompletionObject } from '../../../services/prepare/PrepareUtils';
import PrepareReturnVirApi from '../../../../../services/api/prepareReturnVirApi';

const FileReturnVirTask = (props) => {

    const dispatch = useDispatch()
    const ticketIsOpen = useTicketState(props.ticket);

    // basic interview information
    const [returnType, , province, primaryName, spouseName] = useInterviewInfo(props.ticket);
    const stateTasks = useWorkflowState(props.ticket)

    // tasks to check for in this tile
    const [tasks, setTasks] = useState([WorkflowTasks.RETURN_FILED]);
    const [completingReturn, setCompletingReturn] = useState(false);
    const [baseStatus, completions] = useTaskStatus(props.ticket, tasks);
    // const [returnCompleted, setReturnCompleted] = useState(false);
    const [explorerShowing, setExplorerShowing] = useState(false);
    const [hasUploadedFiles, setHasUploadedFiles] = useState(false);
    const [uploaderOpen, setUploaderOpen] = useState(false);
    const [hasUploaderError, setHasUploaderError] = useState(false);
    // const [completing, setCompleting] = useState('');
    const [returnCompleteErrorT1, setReturnCompleteErrorT1] = useState(false);
    const [status, setStatus] = useState(TaskStatus.NOT_STARTED);
    const [disableReturnCompleted, setDisableReturnCompleted] = useState(false);
    const api = PrepareReturnVirApi.create();
    useEffect(() => {
        var confirmReturnFiled = props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.RETURN_FILED);
        var confirmReadyToFile = props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.VIR_READY_TO_FILE)

        if (confirmReturnFiled.length > 0 || confirmReadyToFile.length === 0) {
            setDisableReturnCompleted(true);
        }

        if (confirmReturnFiled.length === 0 && confirmReadyToFile.length > 0) {
            setDisableReturnCompleted(false);
        }

        if (confirmReadyToFile.length > 0 && status === TaskStatus.NOT_STARTED) {            
            setStatus(TaskStatus.READY_TO_FILE);
        }

        if (confirmReturnFiled.length > 0) {
            setStatus(TaskStatus.COMPLETE);
        }
    }, [props.ticket])

    const handleCompleteReturn = async () => {
        if (status === TaskStatus.NOT_STARTED) {
            setStatus(TaskStatus.IN_PROGRESS);
        }
        if (props.ticket) {
            setCompletingReturn(true);
            // setReturnCompleted(true);
            setReturnCompleteErrorT1(false);

            var response = await api.sendForCompleteReturnTask(props.ticket.id);
            if (response && response.ok) {
                if (response.data.statusCode === 'SUCCESS') {
                    dispatch(TicketActions.getTicket(props.ticket.id));
                    setDisableReturnCompleted(true);
                }
                else if (response.data.statusCode.includes('T1_' + props.ticket.taxYear + '_filed_'))
                {
                    setReturnCompleteErrorT1(true);
                }                
            }
        }
        // setReturnCompleted(false);
        setCompletingReturn(false);
    }

    const getVirReturnFiledDate = () => {
        var confirmReturnFiled = props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.RETURN_FILED)[0] !== undefined;

        if (confirmReturnFiled) {
            var returnFiledDate = null;
            if (props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.RETURN_FILED)[0] !== undefined) {
                returnFiledDate = props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.RETURN_FILED)[0] !== undefined ? JSON.parse(props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.RETURN_FILED)[0].completionData).CompletionDate : null;
            }

            if (returnFiledDate) {
                return returnFiledDate;
            }
        }
        return null;
    }

    const showUploader = () => {
        setUploaderOpen(true);
    }

    const onCloseUploader = () => {
        setUploaderOpen(false);
    }

    const onUploadsComplete = async (filesWereUploaded) => {
        if (filesWereUploaded) {
            setHasUploadedFiles(true);

            var payload = createInProgressTaskCompletionObject((completions || []).find(x => x.status !== TaskStatus.INVALID), null, true);
            saveCompletion(payload);
        }
        setUploaderOpen(false);
    }

    const saveCompletion = async (payload) => {       
        setCompletingReturn(false);
    }

    const showExplorer = () => {
        setExplorerShowing(true);
    }

    const onExplorerClose = () => {
        setExplorerShowing(false);
    }

    const getFileId = (taskId) => {
        var cs;
        var taskCompletions = props.ticket.taskCompletionStates;

        cs = taskCompletions.filter(c => c.workflowTaskId === taskId);

        if (cs && cs[0] && cs[0].status === 'CompletedSuccessfully')
            return true;

        return false;
    }

    const handleLaunchTPSAction = () => {
        if (status === TaskStatus.NOT_STARTED) {
            setStatus(TaskStatus.READY_TO_FILE);
        }        
        let myWindow = window.open();
        myWindow.location.href = localStorage.getItem('tps_base_uri') + `/${props.ticket.taxYear}/return/${props.ticket.viewModelId}/efile/efile?isvir=true`;
    }
    
    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.FILE_RETURN_VIR}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/FileReturn.htm'
                    descriptions={['FileReturnVirTask.Step1','FileReturnVirTask.Step1Info1']} />
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1'>
                    <div className='step-center-container'>
                        {props.ticket &&
                            <Button
                            elementId='launch-tps-btn'
                            labelKey='PrepareTask.LaunchTPSBtn'
                            buttonStyles='secondary'
                            onClick={handleLaunchTPSAction}
                            loading={false}
                            />}
                     </div>
                </div>
                <div className='prep-border' />
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    descriptions={['FileReturnVirTask.Step2', 'FileReturnVirTask.Step2Info1']} />                
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    {props.ticket &&
                        <Fragment>
                            <div className='step-center-container'>
                                <Button
                                    elementId='file-return-doc-manage-btn'
                                    labelKey='DocUploadTask.ViewManage'
                                    buttonStyles='secondary'
                                    onClick={showExplorer}
                                />
                                <Button
                                    elementId='file-return-doc-upload-btn'
                                    labelKey='PrepareTask.UploadDocs'
                                    buttonStyles='secondary'
                                    onClick={showUploader}
                                    disabled={status === TaskStatus.COMPLETE || !ticketIsOpen}
                                />
                            </div>
                            {hasUploaderError &&
                                <TaskErrorText errorKey='PrepareTask.ErrorUploader' />
                            }
                        </Fragment>
                    }
                </div>                
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    descriptions={['FileReturnVirTask.Step3', 'FileReturnVirTask.Step3Info1']} />
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <h4><LoadingTextValue value={primaryName} /></h4>
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                        <h4><LoadingTextValue value={spouseName} /></h4>
                    </div>
                }
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <VerticalNameChildren
                        textKey="FileReturnVirTask.SignedOn"
                        loading={!props.ticket}>
                        <p className='p1 medium-weight'>
                            <DateTime dateAndTime value={getVirReturnFiledDate()} fallbackValue={<EmdashText />} />
                        </p>
                    </VerticalNameChildren>
                </div>                
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1'>
                    <div className='step-center-container'>
                        {props.ticket &&
                            <Button
                            elementId='return-complete-btn'
                            labelKey='FileReturnVirTask.CompleteReturn'
                            buttonStyles='secondary'
                            onClick={handleCompleteReturn}
                            loading={completingReturn}
                            disabled={disableReturnCompleted}
                            />}                        
                    </div>
                    <div>{returnCompleteErrorT1 &&
                        <TaskErrorText errorKey='FileReturnVirTask.ErrorMissingDocUploadT1' />
                    }</div>
                </div>
            </div>
            <DoxExplorer ticket={props.ticket} show={explorerShowing}
                onClose={onExplorerClose}
            />
            <DoxUploader ticket={props.ticket} show={uploaderOpen}
                layoutType={'desktop'} onUploadsComplete={onUploadsComplete} onClose={onCloseUploader}
            />
        </WorkflowTask>
    );
}

FileReturnVirTask.whyDidYouRender = false;

FileReturnVirTask.propTypes = {
    ticket: PropTypes.object
}

export default FileReturnVirTask